function percentComplete({ current, total }) {
  const x = parseInt(current, 10) / parseInt(total, 10);
  const percent = Math.round(x * 100);

  return Number.isNaN(percent) ? '0%' : `${percent}%`; // || typeof perc === Infinity
}

export default percentComplete;
